<div mat-dialog-content>
    <div class="iframeContainer">
        <iframe id="walletIframe" [src]="data.url | safe" frameborder="0" width="100%" [height]="iframeHeight"></iframe>
    </div>
</div>
